export type AppConstants = {
  appUrl: string;
  devStackTrace: boolean;
  onHydrationError: 'log-info' | 'log-error' | 'throw';
  debugXhr: boolean;
  allowRobots: boolean;
  filestackMockEnabled: boolean;
  storybook: boolean;
};

export function getAppConstants(): AppConstants {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return typeof window === 'undefined'
    ? // @ts-expect-error intentionally not exposing global appConstants
      global.appConstants
    : window.Idealist.appConstants;
}
